import {
  ADD_PLACEHOLDER_BORDER_SIZE,
  LOAD_PLACEHOLDER_BORDER_SIZE,
} from './../../action-types/bookproperties';

export const STATE_KEY = 'placeholderBorderSize';

export const placeholderBorderSize = (state = 0, action) => {
  switch (action.type) {
    case ADD_PLACEHOLDER_BORDER_SIZE: {
      return action.borderSize;
    }

    case LOAD_PLACEHOLDER_BORDER_SIZE: {
      return action.size;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/placeholderBorderSize.js